/* eslint-disable no-shadow */
const state = {
	category: [],
	activeCategories: []
}

const getters = {
	getCategoryData: state => state.category,
	getActiveCategories: state => state.activeCategories,
	getActiveCategory: (state) => {
		if (state.activeCategories.length > 0) {
			return state.activeCategories[0]
		}
		return null
	},
	isMultipleCategory: state => state.activeCategories.length > 1
}

const mutations = {
	setCategoryMutation: (state, payload) => {
		state.category = payload
	},
	setActiveCategoriesMutation: (state, payload) => {
		state.activeCategories = payload
	},
	updateActiveCategoryMutation: (state, payload) => {
		state.activeCategories = payload
	},
	clearCategoryMutation: (state) => {
		state.category = []
	}
}

const actions = {
	setCategoryData: ({
		commit
	}, payload) => {
		commit('setCategoryMutation', payload)
	},
	setActiveCategories: ({
		commit
	}, payload) => {
		commit('setActiveCategoriesMutation', payload)
	},
	clearCategoryData: ({
		commit
	}, payload) => {
		commit('clearCategoryMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
